/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gcskew_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. FASTA headers, whitespace and numbers are stripped automatically before the skew is computed.`)
};

const es_gcskew_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. Las cabeceras FASTA, los espacios en blanco y los números se eliminan automáticamente antes de calcular el sesgo.`)
};

const de_gcskew_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. FASTA-Header, Leerzeichen und Zahlen werden vor der Berechnung des Skews automatisch entfernt.`)
};

const nl_gcskew_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. FASTA-headers, witruimte en cijfers worden automatisch verwijderd voordat de skew wordt berekend.`)
};

const fr_gcskew_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. Les en-têtes FASTA, espaces et chiffres sont supprimés automatiquement avant le calcul du biais.`)
};

const it_gcskew_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. Le intestazioni FASTA, gli spazi bianchi e i numeri vengono rimossi automaticamente prima di calcolare lo skew.`)
};

const pt_br2_gcskew_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Cabeçalhos FASTA, espaços em branco e números são removidos automaticamente antes do cálculo do skew.`)
};

const pt_gcskew_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Os cabeçalhos FASTA, espaços em branco e números são removidos automaticamente antes de calcular a assimetria.`)
};

const ja_gcskew_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。スキューを計算する前に、FASTAヘッダー、空白、数字が自動的に除去されます。`)
};

const zh_gcskew_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接受。在计算偏斜之前，FASTA 标题、空白和数字会被自动去除。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gcskew_faq_a4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gcskew_faq_a4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gcskew_faq_a4", locale)
	if (locale === "en") return en_gcskew_faq_a4(inputs)
	if (locale === "es") return es_gcskew_faq_a4(inputs)
	if (locale === "de") return de_gcskew_faq_a4(inputs)
	if (locale === "nl") return nl_gcskew_faq_a4(inputs)
	if (locale === "fr") return fr_gcskew_faq_a4(inputs)
	if (locale === "it") return it_gcskew_faq_a4(inputs)
	if (locale === "pt-BR") return pt_br2_gcskew_faq_a4(inputs)
	if (locale === "pt") return pt_gcskew_faq_a4(inputs)
	if (locale === "ja") return ja_gcskew_faq_a4(inputs)
	return zh_gcskew_faq_a4(inputs)
};